import { useQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useMe(options) {
    return useQuery({
        refetchInterval: (query) => options?.refetchInterval?.(query.state.data) ?? false,
        queryKey: queryKeys.me(),
        queryFn: () => getNookClient().getMe(),
        // A 401 is an answer, not a blip. Retrying it three times just delays the
        // signed-out render by a few seconds.
        retry: (failureCount, error) => !(error instanceof Error && "status" in error && error.status === 401) &&
            failureCount < 2,
    });
}
//# sourceMappingURL=use-me.js.map